module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-down-right-aa3c7a82948db3b4e0f691af5b52ac14.svg";